export default __webpack_public_path__ + "static/media/news.2c093343.svg";